<template>
  <div>
    <h2 class="text-xs-center mb-3 hidden-xs-only">
      <v-btn 
        icon
        class="primary"
        @click="movePrevWeek()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      {{ year }} {{ $t('page.matches.week') }} [ {{ week }} ]  <small>{{ weekDates.firstDay }} <v-icon>code</v-icon> {{ weekDates.lastDay }}</small>
      <v-btn 
        icon
        class="primary"
        @click="moveNextWeek()">
        <v-icon>arrow_forward</v-icon>
      </v-btn>
    </h2>
    <h2 class="text-xs-center mb-3 hidden-sm-and-up">
      <div>{{ year }} {{ $t('page.matches.week') }} [ {{ week }} ]</div>
      <div><small>{{ weekDates.firstDay }} <v-icon>code</v-icon> {{ weekDates.lastDay }}</small></div>
      <div>
        <v-btn 
          icon
          class="primary"
          @click="movePrevWeek()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-btn 
          icon
          class="primary"
          @click="moveNextWeek()">
          <v-icon>arrow_forward</v-icon>
        </v-btn>
      </div>
    </h2>
  </div>
</template>

<script>
import DateHelper from '@/lib/DateHelper'
// const debug = require('debug')('OD::WeekNavigate')

export default {
  name: 'WeekNavigate',
  components: {},
  mixins: [],
  props: {
    year: {
      type: String,
      required: true,
    },
    week: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    weekDates() {
      const dates = DateHelper.getWeekDates(this.year, this.week)
      return { firstDay: dates[0], lastDay: dates[6] }
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    movePrevWeek() {
      const numWeekYear = 52
      let newYear = this.year
      let newWeek = parseInt(this.week) - 1
      if (newWeek < 1) {
        newWeek = numWeekYear
        newYear = parseInt(newYear) - 1
      }
      this.$emit('movePrevWeek', {
        year: newYear,
        week: newWeek,
      })
    },
    moveNextWeek() {
      const numWeekYear = 52
      let newYear = this.year
      let newWeek = parseInt(this.week) + 1
      if (newWeek > numWeekYear) {
        newWeek = 1
        newYear = parseInt(newYear) + 1
      }
      this.$emit('moveNextWeek', {
        year: newYear,
        week: newWeek,
      })
    },
  },
}
</script>

<style lang="scss">
</style>
